const BASE_URL = "https://dashboardapi.honeycomb.ai";
export const REGISTER_USER = () => BASE_URL + '/signup';
export const REGISTER_USER_BY_ID = () => BASE_URL + '/signupByID';
export const LOGIN_USER = () => BASE_URL + '/login';
export const CLIENT_INFO = () => BASE_URL + '/user';
export const ADD_LOCATION = () => BASE_URL + '/addLocation';
export const REMOVE_LOCATION = (id) => BASE_URL + '/removeLocation/' + id;
export const RESTAURANT_ID_URL = (id) => BASE_URL + '/restaurant/' + id;
export const CHECK_URL = (url) => BASE_URL + '/url/' + url;
export const SEND_MENUS = () => BASE_URL + '/menu';
export const SUBSCRIBE_URL = () => BASE_URL + '/subscribe';
export const DIETARY_INFO_URL = (id) => BASE_URL + '/dietaryInformation/' + id;
export const EDIT_LOCATION_URL = (id) => BASE_URL + '/editLocation/' + id;
export const UPDATE_MENU_URL = () => "https://hooks.zapier.com/hooks/catch/177201/f55uic/";
export const POST_AD = () => BASE_URL + '/ad';

/**
 * Returns the appropriate analytics URL depending on id of request
 * @param {int} id   : restaurant id
 */
export const ANALYTICS_URL = (id) => BASE_URL + '/analytics/' + id;

/**
 * Finds the label of the maximum element in an array
 * @param {int[]} data to search for max
 * @param {string[]} labels corresponding to the data
 * @return name of label corresponding to maximum element
 */
export const maxLabelFinder = (data, labels) => {
    let maxValue = 0;
    let maxName = "";
    for(let i =0; i<data.length; i++){
        if(data[i] > maxValue){
            maxValue = data[i];
            maxName = labels[i];
        }
    }
    return maxName;
}

export const CLICKS_URL = (id) => BASE_URL + '/click/' + id;

const EMBED_SCRIPT = "<script type='application/javascript' src='https://honeycomb.ai/embed-v6.js'></script>";
export const EMBED_BUTTON_CODE = (restaurantURL, size, colour, display) => `<div class='honeycomb' data-name='${restaurantURL}' data-size='${size}' data-colour='${colour}' data-display='${display}'></div>
${EMBED_SCRIPT}`;
export const EMBED_BUTTON_IMG = (size, colour) => `img/buttons/button-${colour}-${size}.png`;
export const SMALL_BUTTON = (restaurantURL) => `<div style="position: relative;width: 225px;height: 81px;"><a class="typeform-share" href="https://eat.app.link/${restaurantURL}" data-mode="drawer_left" target="_blank"><div style="position: relative;width:225px;height:81px;margin: 0px auto;background-image: url(https://www.honeycomb.ai/button3.svg);color:transparent"></div></a><script>(function(){if(window.innerWidth > 800 & window.innerHeight > 600){var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm_share";if(!gi.call(d,id)){ js=ce.call(d,"script"); js.id=id; js.src="https://honeycomb.ai/embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q)}}})()</script></div>`
export const BIG_BUTTON   = (restaurantURL) => `<div style="position: relative;width: 300px;height: 108px;"><a class="typeform-share" href="https://eat.app.link/${restaurantURL}" data-mode="drawer_left" target="_blank"><div style="position: relative;width:300px;height:108px;margin: 0px auto;background-image: url(https://www.honeycomb.ai/button2.svg);color:transparent"></div></a><script>(function(){if(window.innerWidth > 800 & window.innerHeight > 600){var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm_share";if(!gi.call(d,id)){ js=ce.call(d,"script"); js.id=id; js.src="https://honeycomb.ai/embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q)}}})()</script></div>`
export const DIET_TAGS = [
    {
        name: "allergyFriendly", value: 1
    },
    {
        name: "veggieFriendly", value: 2,
    },
    {
        name: "vegetarian", value: 4,
    },
    {
        name: "veganFriendly", value: 8,
    },
    {
        name: "vegan", value: 16
    },
    {
        name: "gfFriendly", value: 32
    },
    {
        name: "tamariSauce", value: 64
    },
    {
        name: "gfFoodPrep", value: 128
    },
    {
        name: "glutenFree", value: 256
    },
    {
        name: "halal", value: 512
    },
    {
        name: "kosher", value: 1024
    }
];


export const ERROR_MESSAGES = {
    MIN_PASS_LENGTH : 8,
    FORGOT_RESPONSE : "Thanks! You should get a reset email shortly.",
    INVALID_EMAIL   : "Invalid email!",
    MISSING_PASSWORD: "Please enter your password!",
    PASSWORD_LENGTH : "Password must be atleast 8 characters!",
    PASSWORD_MATCH  : "Passwords do not match!",
    MISSING_INFO    : "Please ensure all fields are filled out!",
    OTHER           : "Please double check your credentials.",
    SOCIAL_ERROR    : "Could not log you in with your social media account at this time.",
    NO_DELETE       : "Could not delete your location at the moment. Check if you're connected to the internet.",
    UPLOAD_ERROR    : "Could not process your upload at the moment. Please try again later."
}

export const CAROUSEL_SETTINGS = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
}

export const NOTIFICATIONS = {
    LOCATION_ADDED      : "You successfully added a restaurant. We will notify you when your menu is ready.",
    LOCATION_UPGRADE    : "Upgrade Plan to Add More Locations",
    LOCATION_DELETED    : "Succesfully Deleted Location",
    LOCATION_EDITED     : "Location Succesfully Edited",
    MENU_UPLOAD         : "Menu Update Upload Succesful"
}



// WEBPACK FOOTER //
// ./src/config.js